import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import { FaCog } from 'react-icons/fa';
import dayjs from 'dayjs';
import SettingsDialogComparison from '../Dialogs/SettingsDialogComparison';
import SankeyDiagram from '../Charts/SankeyDiagram.jsx';

class ComparePanel extends React.Component {
  constructor(props) {
    super();
    this.state = {
      showSettingsDialog: false,
      settings: {
        teamCount: 10,
        organismCount: 10,
        publicationCount: 10,
      }
    };
    this.nodeData = [];
    this.linkData = [];
  }

  componentWillReceiveProps(nextProps) {
    this.updateVisualData(nextProps, this.state.settings)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextState !== this.state)
      return true;
    if(nextProps.compact !== this.props.compact)
      return true;
    if(nextProps.filterTimeStamp !== this.props.filterTimeStamp)
      return true;
    return false
  }

  toggleSettingsDialog = (() => {
    this.setState(prevState => ({
      showSettingsDialog: !prevState.showSettingsDialog,
    }));
  }).bind(this)

  applySettings = (settings => {
    this.updateVisualData(this.props, settings)
    this.setState({settings})
  }).bind(this)

  updateVisualData(props, settings) {
    if(!props.base || !props.filtered)
      return;
    let {
      listOrganism,
      listAuthorFull,
      listTeam,
      listPaper,
      listPublication,
      dataListEMDs,
    } = props.base;
    let {
      filterResults,
      filterMap,
      filterOrganisms,
      filterTeams,
      filterPublications,
    } = props.filtered;

    let {teamCount, organismCount, publicationCount} = settings;
    let nodeDataTeam = filterTeams.slice(0, teamCount).map(t => ({name: listAuthorFull[t.team[0]].name, index: t.team[0]}));
    let nodeDataOrganism = filterOrganisms.slice(0, organismCount).map(o => ({name: o.name, index: o.id}));
    let nodeDataPublication = filterPublications.slice(0, publicationCount).map(o => ({name: o.name, index: o.id}));
    teamCount = nodeDataTeam.length;
    organismCount = nodeDataOrganism.length;
    publicationCount = nodeDataPublication.length;
    let linkCountP2T = teamCount * (publicationCount+1);
    let linkCountT2O = teamCount * (organismCount+1);
    let linkWeights = Array.from({length: linkCountP2T + linkCountT2O}, () => 0);
    dataListEMDs.forEach(d => d.f.forEach(f => {
      let fidx = nodeDataTeam.findIndex(t => t.index === f);
      let pidx = nodeDataPublication.findIndex(t => t.index === d.p);
      if(fidx < 0) return;
      if(pidx < 0) pidx = publicationCount;
      ++linkWeights[teamCount * pidx + fidx];
    }))
    dataListEMDs.forEach(d => d.f.forEach(f => d.o.forEach(o => {
      let fidx = nodeDataTeam.findIndex(t => t.index === f);
      let oidx = nodeDataOrganism.findIndex(t => t.index === o);
      if(fidx < 0) return;
      if(oidx < 0) oidx = organismCount;
      ++linkWeights[linkCountP2T + teamCount * oidx + fidx];
    })))
    nodeDataPublication.push({name: 'Other publications'});
    nodeDataOrganism.push({name: 'Other organisms'});
    this.nodeData = nodeDataPublication.concat(nodeDataTeam).concat(nodeDataOrganism);
    this.linkData = linkWeights.map((w, index) => (index < linkCountP2T ? {
      source: nodeDataTeam[index % teamCount].name,
      target: nodeDataPublication[Math.floor(index / teamCount)].name,
      value: w,
    } : {
      source: nodeDataOrganism[Math.floor((index - linkCountP2T) / teamCount)].name,
      target: nodeDataTeam[(index - linkCountP2T) % teamCount].name,
      value: w,
    })).filter(l => l.value)
  }

  render() {
    let {sizeFactor} = this.props;
    if(!sizeFactor) sizeFactor = 1;
    return (
      <div>
        <Row>
          <Col>
            <SankeyDiagram
              width={(this.props.compact ? 400 : this.props.extend ? 800 : 600) * sizeFactor}
              height={445 * sizeFactor}
              data={this.nodeData}
              links={this.linkData}
            />
          </Col>
        </Row>
        <Button
          className="settings"
          style={{ position: 'absolute', top: '30px', right: '15px' }}
          onClick={this.toggleSettingsDialog}
        ><FaCog /></Button>
        <SettingsDialogComparison
          isOpen={this.state.showSettingsDialog}
          toggle={this.toggleSettingsDialog}
          settings={this.state.settings}
          onApply={this.applySettings}
        />
      </div>
    )
  }
}

export default ComparePanel;
